import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerModule } from 'ngx-spinner';
import { AlertService } from '../core/services/components/alert.service';
import { ConfirmationDialogService } from '../core/services/components/confirmationDialog.service';
import { AlertComponent } from './alert';
import { ConfirmationDialogComponent } from './confirmation-dialog/confirmation-dialog.component';
import { NgSpinnerComponent } from './ng-spinner/ng-spinner.component';

@NgModule({
	imports: [CommonModule, NgbModule, NgxSpinnerModule],
	declarations: [AlertComponent, ConfirmationDialogComponent, NgSpinnerComponent],
	exports: [AlertComponent, ConfirmationDialogComponent, NgSpinnerComponent],
	providers: [AlertService, ConfirmationDialogService],
})
export class ShareModule {}
